// Exact pre-redesign defaults only. Projection must not mutate raw preparation storage.
export const agentiqueRagLegacy = {
  title: 'IA agentique + RAG opérationnel',
  family: 'IA & données',
  importance: 'critique',
  ownerIds: ['db', 'ed', 'eh', 'fm'],
  tags: ['IA', 'RAG', 'bots', 'production', 'adoption'],
  summary: 'Aligner la vision IA agentique : bots en production, RAG documentaire, sécurité, adoption humaine et valeur client.',
  whyNow: 'L’IA avance plus vite que l’organisation. Il faut un cadre simple pour que les humains adoptent sans perdre le contrôle.',
  enrichedContext: [
    'AIKUB ERP contient déjà des surfaces BotOps, documents/RAG, contrats, contacts et workflows business.',
    'PRIsME contient la section IA Agentic et des cartes dédiées à des agents et tâches.',
    'Les courriels récents montrent des sujets AIKUB, Zia, Maglio et Atlas données actifs.'
  ],
  questions: ['Quels bots sont vraiment en production aujourd’hui?', 'Quels irritants humains l’IA doit régler en premier?', 'Comment éviter l’effet “trop vite pour l’humain”?'],
  decisions: ['Choisir 3 cas d’usage IA prioritaires.', 'Nommer un owner adoption humaine.', 'Définir les règles RAG/source de vérité.'],
  signals: ['BotOps et RAG existent dans AIKUB ERP.', 'PRIsME IA Agentic devient la vitrine interne.', 'Adoption et sécurité doivent avancer ensemble.'],
  evidence: ['AIKUB_erp app/(app)/botops', 'AIKUB_erp app/(app)/documents/rag', 'PRIsME_Master_BZ IAAgentic'],
};
